import * as React from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined, LoadingOutlined } from '@ant-design/icons';

const StatusInfo = (props: any): React.ReactElement => {
  const { isConnected } = props;
  return (
    <>
      {isConnected
        ? <Tag icon={<CheckCircleOutlined />} color='success'>Connected</Tag>
        : <Tag icon={<ExclamationCircleOutlined />} color="default">Pending Setup</Tag>}
    </>
  );
}

export default StatusInfo;